const translations = {
    'wildlife.byAge': 'Wildlife by age',
    'wildlife.none': 'No wildlife.',
    'wildlife.section': 'Wildlife',
    'wildlife.total': 'Wildlife total: %d',
};

export default translations;
